<div *ngIf="!skeleton" class="listing-container" [ngClass]="{selectable: selectable, selected: selected, padding: padding, large: large, disabled: disabled}">
  <div class="listing" [ngClass]="{padding: padding, underline: underline, 'small-padding': smallSpacing}">
    <div class="main-content">
      <avatar *ngIf="hasAvatar && !donutAvatar" [ngClass]="{small: smallAvatar}" [text]="avatarText || title" [url]="photoURL" [noFill]="noFillAvatar"></avatar>
      <donut *ngIf="hasAvatar && donutAvatar" class="avatar" [ngClass]="{small: smallAvatar}" [color]="avatarDonutColor" [percentage]="avatarDonutValue"></donut>
      <div class="text" [ngClass]="{'no-avatar': !hasAvatar, 'small-margin': smallSpacing}">
        <span *ngIf="aboveTitle" class="above-title">{{aboveTitle}}</span>
        <div class="title-line">
          <span class="title">{{title}}</span>
          <img src="assets/edit-no-whitespace.svg" *ngIf="canEdit && !isDirty" class="edit-icon" title="Edit"
            (click)="editHandler($event)" />
          <div *ngIf="isDirty && !dotColor" class="save-dot" [ngClass]="{error: hasError}"></div>
          <div *ngIf="dotColor" class="save-dot" [style.background]="dotColor"></div>
        </div>
        <span class="desc" *ngIf="!scoredAssignment && hasDesc && desc && desc.length > 0">{{desc}}</span>
        <span class="desc wrap" *ngIf="scoredAssignment && hasDesc && scoredAssignment.scoreNames.length > 0">
          <span *ngFor="let scoreName of scoredAssignment.scoreNames; index as i">
            <span [title]="scoredAssignment.getScoreTitleText(scoreName)">{{scoreName}}</span><span> ({{scoredAssignment.getAssessmentTakerStrings(scoreName).length}}){{i + 1 < scoredAssignment.scoreNames.length ? ', ' : ''}}</span>
          </span>
          <span *ngIf="scoredAssignment.scoreNames.length == 0">No scores</span>
        </span>
        <span class="desc" *ngIf="descTwo && descTwo.length > 0" [ngClass]="measurementColor">{{descTwo}}</span>
        <span class="desc" *ngFor="let eDesc of extraDescs">{{eDesc}}</span>
        <div class="network" *ngIf="network">
          <div class="scores" *ngIf="needsScores">
            <div class="donut-container">
              <div *ngIf="!scores" class="donut loading skeleton-animation"></div>
              <div *ngIf="scores" class="donut">
                <donut color="#a3d3ff" [percentage]="getScore('SYMPTOM')"></donut>
              </div>
              <span class="donut-label">Symptom</span>
            </div>
            <div class="donut-container">
              <div *ngIf="!scores" class="donut loading skeleton-animation"></div>
              <div *ngIf="scores" class="donut">
                <donut color="#a3d3ff" [percentage]="getScore('TREATMENT')"></donut>
              </div>
              <span class="donut-label">Treatment</span>
            </div>
            <div class="donut-container">
              <div *ngIf="!scores" class="donut loading skeleton-animation"></div>
              <div *ngIf="scores" class="donut">
                <donut color="#a3d3ff" [percentage]="getScore('LOGGING')"></donut>
              </div>
              <span class="donut-label">Logging</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="buttonUrl" class="button" [ngClass]="{disabled: buttonDisabled}" (click)="buttonHandler($event)">
        <img [src]="buttonUrl"/>
      </div>
      <div class="measurement" *ngIf="measurement && time">
        <span class="measurement-value" [ngClass]="measurementColor">{{measurement}}</span>
        <span class="measurement-time" *ngIf="measurement != 'No Data' && measurement != 'Unlogged'">{{time}}</span>
      </div>
    </div>
    <span *ngIf="rightText" class="right-text">{{rightText}}</span>
  </div>
</div>
<div *ngIf="skeleton" class="listing-container skeleton" [ngClass]="{padding: padding, large: large}">
  <div class="listing" [ngClass]="{padding: padding, underline: underline, 'small-padding': smallSpacing}">
    <div class="main-content">
      <div *ngIf="hasAvatar && !donutAvatar" class="avatar skeleton-animation" [ngClass]="{small: smallAvatar}"></div>
      <donut *ngIf="hasAvatar && donutAvatar" class="avatar skeleton-animation" [ngClass]="{small: smallAvatar}" [skeleton]="true"></donut>
      <div class="text" [ngClass]="{'no-avatar': !hasAvatar, 'small-margin': smallSpacing}">
        <span *ngIf="aboveTitle" class="above-title skeleton-animation"></span>
        <div class="title-line skeleton-animation" [ngClass]="{'long-title-skeleton': longTitleSkeleton}"></div>
        <span *ngIf="hasDesc" class="desc skeleton-animation"></span>
        <span *ngFor="let _ of extraDescs" class="desc skeleton-animation"></span>
      </div>
    </div>
    <span *ngIf="rightText" class="right-text skeleton-animation"></span>
  </div>
</div>
